module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bingdao.dfe57f4c.jpg";